(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function easeInOutCubic(progress) {
    return progress < 0.5
      ? 4 * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 3) / 2;
  }

  function smoothScrollToTop() {
    var root = document.scrollingElement || document.documentElement;
    var start = root.scrollTop || window.pageYOffset || 0;

    if (start <= 0) return;

    if (prefersReducedMotion()) {
      window.scrollTo(0, 0);
      return;
    }

    var duration = Math.min(900, Math.max(450, start * 0.4));
    var startTime = null;
    var cancelled = false;

    function cancelScroll() {
      cancelled = true;
    }

    window.addEventListener('wheel', cancelScroll, { passive: true, once: true });
    window.addEventListener('touchstart', cancelScroll, { passive: true, once: true });
    window.addEventListener('keydown', cancelScroll, { once: true });

    function step(timestamp) {
      if (cancelled) return;

      if (!startTime) startTime = timestamp;

      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var nextScrollTop = Math.round(start * (1 - easeInOutCubic(progress)));

      window.scrollTo(0, nextScrollTop);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  function initBackToTopButtons() {
    document.querySelectorAll('[data-wls-back-to-top]:not([data-wls-back-to-top-init])').forEach(function (button) {
      button.setAttribute('data-wls-back-to-top-init', 'true');

      var ticking = false;

      function updateVisibility() {
        var threshold = window.innerHeight;
        var isVisible = (window.scrollY || window.pageYOffset || 0) >= threshold;
        button.classList.toggle('is-visible', isVisible);
        ticking = false;
      }

      function requestUpdate() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateVisibility);
        }
      }

      button.addEventListener('click', function (event) {
        event.preventDefault();
        smoothScrollToTop();
      });

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', updateVisibility);
      updateVisibility();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackToTopButtons);
  } else {
    initBackToTopButtons();
  }

  document.addEventListener('shopify:section:load', initBackToTopButtons);
})();
